import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { alpha } from "@mui/material/styles";
import Eyebrow from "@/components/common/Eyebrow";
import { WHY_NIRVAGOO } from "@/constants/homeContent";

export default function WhyNirvagoo() {
  return (
    <Box component="section" id="why-nirvagoo" sx={{ maxWidth: 1400, mx: "auto", px: { xs: 3, lg: 6 }, pt: { xs: 8, md: 10 } }} data-testid="why-nirvagoo-section">
      <Box sx={{ mb: 5, maxWidth: 560 }}>
        <Eyebrow sx={{ mb: 1.5 }}>Why Nirvagoo</Eyebrow>
        <Typography component="h2" className="font-serif-display" sx={{ fontSize: { xs: 28, md: 34 } }}>
          More than villas. Better getaways.
        </Typography>
      </Box>
      <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr 1fr", md: "repeat(4, 1fr)" }, gap: { xs: 3, md: 4 } }}>
        {WHY_NIRVAGOO.map(({ Icon, title, text }) => (
          <Box key={title} data-testid={`why-item-${title.toLowerCase().replace(/\s+/g, "-")}`} sx={{ textAlign: "center" }}>
            <Box sx={{ width: 44, height: 44, borderRadius: "50%", bgcolor: (t) => alpha(t.palette.primary.main, 0.12), display: "flex", alignItems: "center", justifyContent: "center", mb: 1.5, mx: "auto" }}>
              <Icon size={19} className="text-gold" />
            </Box>
            <Typography sx={{ fontWeight: 600, fontSize: 15, mb: 0.5 }}>{title}</Typography>
            <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.5 }}>{text}</Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
